import styled from '@emotion/styled';
import { css } from '@emotion/react';
import COLORS from '@zola/zola-ui/src/styles/emotion/colors3';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import CaretV2Icon from '@zola/zola-ui/src/components/SvgIcons/CaretV2';

export const Container = styled.div`
  margin-top: 32px;
`;

export const ulBaseStyles = css`
  margin: 0;
  padding: 0;
  list-style-type: none;
  padding-inline-start: 0;
`;

export const liBaseStyles = css`
  padding-inline-start: 0;
  margin: 0;
  padding: 0;
  display: block;
`;

export const Title = styled.div`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
  color: ${COLORS.BLACK_100};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  padding-bottom: 20px;
`;

export const TitleSub = styled.div`
  font-family: ${FONT.FONT_FAMILY_NEW_SPIRIT};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
  color: ${COLORS.BLACK_050};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  padding-bottom: 20px;
  line-height: 44px;
`;

export const Link = styled.a`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  display: flex;
  align-items: center;
  color: ${COLORS.BLACK_100};
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)};
  padding-bottom: 16px;
  text-decoration: none;
`;

export const SectionGroup = styled.div`
  border-bottom: 1px solid ${COLORS.BLACK_030};
  padding: 16px 0;
`;

export const Icon = styled.img`
  display: inline-block;
  margin: 0 5px -1px 0;
  width: 18px;
`;

export const MenuParent = styled.a`
  display: flex;
  justify-content: space-between;
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  color: ${COLORS.BLACK_100};
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)};
  padding-bottom: 16px;
  vertical-align: middle;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`;

export const InnerUL = styled.ul`
  &:not(:last-of-type) {
    border-bottom: 1px solid ${COLORS.BLACK_030};
    margin-bottom: 20px;
  }
`;

export const CaretRight = styled(CaretV2Icon)`
  margin: 4px 0;
`;

export const FindCouple = styled.a`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_BOLD};
  color: ${COLORS.BLACK_100};
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)};
  padding-bottom: 16px;
  text-decoration: none;
  border-bottom: 1px solid ${COLORS.BLACK_015};
  display: flex;
`;
